import BrandCarousel from './Carousel';

export default BrandCarousel;
